import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import styled from 'styled-components';
import { useTranslations } from '../../hooks/use_translations.js';
import { useThemeContext } from '../../styles/themes/themes.js';
import { ActivateToEdit } from '../ActivateToEdit/ActivateToEdit.js';
import { Input } from '../Input/Input.js';
import { jsx } from 'react/jsx-runtime';

var ActivateToEditInputField = styled(Input).withConfig({
  displayName: "ActivateToEditInput__ActivateToEditInputField",
  componentId: "sc-1bccsjh-0"
})(["&&{flex-grow:1;margin-inline-end:76px;", ";}&& :focus{border-color:", ";}"], function (_ref) {
  var error = _ref.error,
    theme = _ref.theme;
  return error && "\n        border: 1px solid ".concat(theme.alertColors.error, ";\n        \n    ");
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.CTAColors.primary;
});
var ActivateToEditInput = function ActivateToEditInput(_ref3) {
  var disabled = _ref3.disabled,
    onBlur = _ref3.onBlur,
    onCancel = _ref3.onCancel,
    _onChange = _ref3.onChange,
    onConfirm = _ref3.onConfirm,
    onValidate = _ref3.onValidate,
    placeholder = _ref3.placeholder,
    readOnly = _ref3.readOnly,
    value = _ref3.value;
  var _useThemeContext = useThemeContext(),
    localization = _useThemeContext.localization;
  var _useTranslations = useTranslations(localization === null || localization === void 0 ? void 0 : localization.translations),
    t = _useTranslations.t;
  var _React$useState = React.useState(value),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    text = _React$useState2[0],
    setText = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    stateEmpty = _React$useState4[0],
    setStateEmpty = _React$useState4[1];
  var onConfirmEdit = function onConfirmEdit(state) {
    var editedState = state || placeholder;
    if (editedState === placeholder) {
      setStateEmpty(true);
    } else {
      setStateEmpty(false);
    }
    setText(editedState);
    if (onConfirm) {
      onConfirm(editedState);
    }
    if (_onChange) {
      _onChange(editedState);
    }
  };
  return /*#__PURE__*/jsx(ActivateToEdit, {
    ariaLabelWriteView: t("ActivateToEdit.editInstructions"),
    value: text,
    onValidate: onValidate,
    hasPlaceholder: stateEmpty,
    readView: /*#__PURE__*/jsx("div", {
      children: text
    }),
    writeView: function writeView(_ref4) {
      var focusRef = _ref4.focusRef,
        setState = _ref4.setState,
        state = _ref4.state,
        validationResponse = _ref4.validationResponse;
      return /*#__PURE__*/jsx(ActivateToEditInputField, {
        ref: focusRef,
        placeholder: placeholder,
        value: state,
        error: !!validationResponse,
        onChange: function onChange(event) {
          return setState(event.target.value);
        }
      });
    },
    onBlur: onBlur,
    onChange: function onChange(state) {
      return _onChange && _onChange(state);
    },
    onConfirm: function onConfirm(state) {
      return onConfirmEdit(state);
    },
    readOnly: readOnly,
    disabled: disabled,
    onCancel: onCancel
  });
};
ActivateToEditInput.displayName = "ActivateToEditInput";

export { ActivateToEditInput };
